/**
 * @link https://mui.com/material-ui/customization/color/
 */

import { Box, Typography, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

const ColorBox = ({ name, color, textColor = "#fff" }) => {
  const copyToClipboard = () => navigator.clipboard.writeText(color);

  return (
    <Box
      sx={{
        backgroundColor: color,
        color: textColor,
        p: 2,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: 100,
        textAlign: "center",
        position: "relative",
      }}
    >
      <Typography variant="body1">{name}</Typography>
      <Typography variant="caption">{`theme.palette.${name?.toLowerCase().replace(/\s+/g, ".")}${/(shy|light)$/.test(name?.toLowerCase() ?? "") ? "" : ".main"}`}</Typography>
      <Typography variant="caption">{color}</Typography>
      <IconButton
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}
        onClick={copyToClipboard}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};

export default ColorBox;
